import {LoadDataState} from "../common/util/asyncdata/reducerUtil";
import {NotificationState} from "./reducer";
import {AOIMonitor as Notification} from "./model";

export const moduleName = "Notifications";

const getNotificationsState = (state): NotificationState => {
    return state[moduleName];
};

const getAllNotifications = (state): Notification[] => {
    const serviceState = getNotificationsState(state);
    return serviceState.allIds.map((id) => serviceState.byId[id]);
};

const getNotificationById = (state, id: string): Notification => {
    const serviceState = getNotificationsState(state);
    return serviceState.byId[id] || null;
};

export const getNotificationRequestState = (state): LoadDataState<Notification[]> => {
    const serviceState = getNotificationsState(state);
    return serviceState.loadNotificationsRequest;
};

export const getNotificationDetailRequestState = (state): LoadDataState<Notification> => {
    const serviceState = getNotificationsState(state);
    return serviceState.loadNotificationDetailRequest;
};

const getCurrentNotification = (state): Notification => {
    const servicesState = getNotificationsState(state);
    return servicesState.byId[servicesState.currentNotificationId];
};

const getCurrentNotificationId = (state): string => {
    const servicesState = getNotificationsState(state);
    return servicesState.currentNotificationId;
};

export const selectors = {
    getAllNotifications,
    getNotificationById,
    getNotificationRequestState,
    getNotificationDetailRequestState,
    getCurrentNotification,
    getCurrentNotificationId,
};